// A $( document ).ready() block.

$( document ).ready(function() {

  function greet(){
			$('#gl-d-searchbox-input').focus();
		}
  
  $(".header__icon-touch--search").on("click",function() {
    
    
    
		setTimeout(greet, 500);
  });
  
  
  $(".desktop-carousel__pagination-arrow").on("click",function() {
	moveCarousel( $(this))
  });
  
  
  function moveCarousel(el){

    var parentDiv = $(el).closest("div.inline-grid.grid");
    var currentIndex = $(parentDiv).data("current-index");
    var increment = 1;
    if($(el).hasClass("desktop-carousel__pagination-arrow--prev")) increment = -1;
    
    if(increment === 1) {
      $(parentDiv).animate({scrollLeft:$(parentDiv).scrollLeft()+$(parentDiv).width()}, 800); 
      $(parentDiv).find(".desktop-carousel__pagination-arrow--prev").removeClass("disabled");
      
      
      if($(parentDiv).scrollLeft()+$(parentDiv).width()+$(parentDiv).width() >= $(parentDiv)[0].scrollWidth) {
        $(parentDiv).find(".desktop-carousel__pagination-arrow--next").addClass("disabled");
      }
      
    }else {
      $(parentDiv).animate({scrollLeft:$(parentDiv).scrollLeft()-$(parentDiv).width()}, 800);
      $(parentDiv).find(".desktop-carousel__pagination-arrow--next").removeClass("disabled");
      
      if($(parentDiv).scrollLeft()-$(parentDiv).width() <= 0) {
        
        $(parentDiv).find(".desktop-carousel__pagination-arrow--prev").addClass("disabled");
      }
    }
    
   
  }
  

  /*$('body').on('click','button[data-quick-add-id]', function(event){
    event.preventDefault(); // prevent default form submission
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:  { id: $(this).attr("data-quick-add-id"), quantity: 1},
      dataType: 'json',
    }).done(function(data) { 
      alert("success"); 
      console.log($('.quick-cart__items .quick-cart__item[data-id="'+data.id+'"]'))
      //const newOrder = [item.variant_id, ...order.filter(i => i !== item.variant_id)];
      console.log(data)

    }).fail(function() { alert("error"); });
  });*/
  
  
});
